import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

// @formatter:off
// tslint:disable:max-line-length
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'paciente'},

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'paciente'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmar', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'reset-password/:id/:token', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'privatenregister', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)},
            //{path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)}
        ]
    },



    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            //{path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)}
        ]
    },

    // Landing routes
    {
        path: '',
       // component  : LandingHomeComponent,
        data: {
            layout: 'empty'
        },
        children   : [
            {path: '', loadChildren: () => import('app/modules/landing/landing.module').then(m => m.LandingModule)},
        ]
    },

    // Admin routes
    {
        path        : '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver
        },
        children: [
            // Dashboards
            {path: 'dashboards', children: [
                {path: '', loadChildren: () => import('app/modules/admin/dashboard/dashboard.module').then(m => m.DashboardModule)},
            ]},
            {
                path: 'catalogo',
                loadChildren: () => import('app/modules/admin/catalogue/catalogue.module').then( m => m.CatalogueModule )
            },

            {path: 'acount', children: [
                {path: 'settings', loadChildren: () => import('app/modules/admin/settings/settings.module').then(m => m.SettingsModule)},
                {path: 'payments', loadChildren: () => import('app/modules/admin/payments/payments.module').then(m => m.PaymentsModule)},
            ]},

            {path: 'doctors', children: [
                {path: '', loadChildren: () => import('app/modules/admin/medico/medico.module').then(m => m.MedicoModule)},
            ]},
            {path: 'agenda', children: [
                {path: '', loadChildren: () => import('app/modules/admin/agenda/agenda.module').then(m => m.AgendaModule)},
            ]},
        ]
    },

    {
        path        : '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'paciente'
            },
            {
                path: 'paciente',
                loadChildren: () => import('app/modules/admin/paciente/paciente.module').then( m => m.PacienteModule ),
                data: {
                    rolesPermitidos: ['ROLE_ADMIN', 'ROLE_NUTRIOLOGO', 'ROLE_ADMIN_AUXILIAR']
                }

            },
            {
                path: 'catalogo/administracion/listado/recetas/todas',
                loadChildren: () => import('app/modules/admin/catalogue/catalogue.module').then( m => m.CatalogueModule ),
                data: {
                    rolesPermitidos: ['ROLE_ADMIN_AUXILIAR']
                }
            }
        ]
    },




    {path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/error/error-404/error-404.module').then(m => m.Error404Module)},
    {path: '**', redirectTo: '404-not-found'}
];
